import { Grid } from "@mui/material";
import React from "react";
import { formatOutput } from "../../../utils/computation/analysis";
import GraphHeader from "../../graphs/GraphHeader";
import ImageGraph from "../../graphs/ImageGraph";

const CorrelationResult = ({ cor }) => {
  const firstColumn = cor.column.charAt(0);
  const secondColumn = cor.column.charAt(3);

  return (
    <div>
      <GraphHeader
        column={cor.column}
        dateTime={cor.dateTime}
        title={cor.title}
        analysisId={cor.id}
        graphs={cor.graphs}
      />

      <Grid
        container
        spacing={{ xs: 2, md: 3 }}
        columns={{ xs: 4, sm: 8, md: 12 }}
        sx={{ color: "#535353" }}
      >
        <Grid item xs={12} sm={12} md={12}>
          <h4>Correlation</h4>
        </Grid>
        <Grid item xs={3} sm={3} md={3}>
          <br />
          <h4>Column {firstColumn}</h4>
          <h4>Column {secondColumn}</h4>
        </Grid>
        <Grid item xs={3} sm={3} md={3}>
          <h4>{firstColumn}</h4>
          <h3>{formatOutput(cor.correlation.corrcoef[0][0])}</h3>
          <h3>{formatOutput(cor.correlation.corrcoef[1][0])}</h3>
        </Grid>
        <Grid item xs={3} sm={3} md={3}>
          <h4>{secondColumn}</h4>
          <h3>{formatOutput(cor.correlation.corrcoef[0][1])}</h3>
          <h3>{formatOutput(cor.correlation.corrcoef[1][1])}</h3>
        </Grid>

        <Grid item xs={12} sm={12} md={12}>
          <h4>Data</h4>
          <h4>Column {cor.column}</h4>
        </Grid>

        <Grid item xs={4} sm={4} md={4}>
          <h4>Method</h4>
          {cor.Methods.isPearson && <h3>Pearson's r</h3>}
          {cor.Methods.isSpearman && <h3>Spearman's rho</h3>}
          {cor.Methods.isKendall && <h3>Kendall's tau</h3>}
        </Grid>
        <Grid item xs={3} sm={3} md={3}>
          <h4>Correlation</h4>
          {cor.Methods.isPearson && (
            <h3>{formatOutput(cor.correlation.pearsonr[0])}</h3>
          )}
          {cor.Methods.isSpearman && (
            <h3>{formatOutput(cor.correlation.spearmanr[0])}</h3>
          )}
          {cor.Methods.isKendall && (
            <h3>{formatOutput(cor.correlation.kendalltau[0])}</h3>
          )}
        </Grid>
        <Grid item xs={3} sm={3} md={3}>
          <h4>P-Value</h4>
          {cor.Methods.isPearson && (
            <h3>{formatOutput(cor.correlation.pearsonr[1])}</h3>
          )}
          {cor.Methods.isSpearman && (
            <h3>{formatOutput(cor.correlation.spearmanr[1])}</h3>
          )}
          {cor.Methods.isKendall && (
            <h3>{formatOutput(cor.correlation.kendalltau[1])}</h3>
          )}
        </Grid>
      </Grid>
      {cor.graphs.isScatterplot ? (
        <ImageGraph
          url={cor.scatterplot}
          title="Scatterplot"
          column={cor.column}
          percent={95}
        />
      ) : null}
    </div>
  );
};

export default CorrelationResult;
